import React from 'react';
import { Tooltip } from 'swag-client-common/components/info/tooltip/tooltip';
import { Placement } from 'swag-client-common/constants';
import { popperProps, tooltipClasses } from 'swag-client-common/components/partials/header-icons/header-icons';
import CSSclasses from 'swag-client-common/components/partials/header-icons/header-icons.scss';
import { BoxAcceptable, BoxAcceptableOrange, NoBoxAcceptable } from './icons';
const NO_ACCEPTABLE_FOR_BOX_TOOLTIP = 'This product cannot be added to a box';
const ACCEPTABLE_FOR_BOX_TOOLTIP = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "This product can be added to a box."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Add it to your cart to begin."));
const getIconSrc = ({
  acceptableForBox,
  isLimitedEdition
}) => {
  const boxAcceptableImg = isLimitedEdition ? /*#__PURE__*/React.createElement(BoxAcceptableOrange, null) : /*#__PURE__*/React.createElement(BoxAcceptable, null);
  return acceptableForBox ? boxAcceptableImg : /*#__PURE__*/React.createElement(NoBoxAcceptable, null);
};
export const HeaderIconsOther = ({
  acceptableForBox,
  isLimitedEdition
}) => /*#__PURE__*/React.createElement(Tooltip, {
  title: acceptableForBox ? ACCEPTABLE_FOR_BOX_TOOLTIP : NO_ACCEPTABLE_FOR_BOX_TOOLTIP,
  mode: "light",
  placement: Placement.RIGHT,
  classes: tooltipClasses,
  PopperProps: popperProps
}, /*#__PURE__*/React.createElement("div", {
  "aria-label": `This product ${acceptableForBox ? 'can' : 'cannot'} be added to a box.`,
  className: CSSclasses.icon
}, getIconSrc({
  acceptableForBox,
  isLimitedEdition
})));